import './AtletizmYarisiForm.css'
import { Button, Label, Input, Spinner, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import WarningModal from './WarningModal'
import Header from '../../Header'
import Loading from '../../Loading'
import ConditionsCheckBox from './ConditionsCheckBox'
import ReactMarkdown from 'react-markdown'
import axios from 'axios'

const KAN_GRUBU_OPTIONS = ['A Rh+', 'A Rh-', 'B Rh+', 'B Rh-', 'AB Rh+', 'AB Rh-', '0 Rh+', '0 Rh-']

const cinsiyetLabel = (c) => (c === 'K' ? 'Kadın' : c === 'E' ? 'Erkek' : '-')

const onlyDigits = (value) => (value || '').toString().replace(/\D/g, '')

const normalizePhone = (value) => onlyDigits(value).replace(/^0+/, '').slice(0, 10)

const Row = ({ label, value, bold }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem' }}>
    <span style={{ color: '#7a8a82' }}>{label}</span>
    <span style={{ fontWeight: bold ? 700 : 500, textAlign: 'right' }}>{value || '-'}</span>
  </div>
)

const AtletizmYarisiForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [preview, setPreview] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(true)

  const [telefonNo, setTelefonNo] = useState('')
  const [adres, setAdres] = useState('')
  const [bloodType, setBloodType] = useState('')
  const [acilKisiAdi, setAcilKisiAdi] = useState('')
  const [acilKisiTelefon, setAcilKisiTelefon] = useState('')

  const [checkbox, setCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isModal, setIsModal] = useState({ title: '', message: '', type: '', active: false })
  const [confirmModal, setConfirmModal] = useState({ open: false, data: null })

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/atletizm-yarisi-preview`, {
        params: { id: state?.basvuruId },
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        const data = res?.data || null
        setPreview(data)
        const u = data?.uye
        if (u) {
          setTelefonNo((prev) => prev || normalizePhone(u.telefon_no))
          setAdres((prev) => prev || (u.adres || ''))
        }
      })
      .catch(() => setPreview(null))
      .finally(() => setPreviewLoading(false))
  }, [])

  const toggleWarningModal = (e) => {
    if (e?.stopPropagation) e.stopPropagation()
    setIsModal((prev) => ({ ...prev, active: !prev.active }))
  }

  const showError = (type, title, message) => {
    setIsModal({ type, title: title || '', message: message || '', active: true })
  }

  const uye = preview?.uye
  const yaris = preview?.yaris
  const basvuruYapilabilir = !!preview?.uygun

  const onFinish = () => {
    if (!basvuruYapilabilir) {
      showError('server_error', preview?.basvuru_var ? 'Başvurunuz Mevcut' : 'Başvuru Yapılamıyor', preview?.mesaj || 'Başvuru bilgileriniz doğrulanamadı.')
      return
    }

    if (telefonNo.length !== 10) {
      showError('failed_phone')
      return
    }

    if (adres.trim().length < 10) {
      showError('failed_required', 'Adres Eksik', 'Lütfen adres bilginizi eksiksiz giriniz.')
      return
    }

    if (!bloodType) {
      showError('failed_required', 'Kan Grubu Seçilmedi', 'Lütfen kan grubunuzu seçiniz.')
      return
    }

    if (acilKisiAdi.trim().length < 3) {
      showError('failed_required', 'Acil Durum Kişisi Eksik', 'Acil durumda ulaşılacak kişinin adı soyadını giriniz.')
      return
    }

    if (acilKisiTelefon.length !== 10) {
      showError('failed_required', 'Acil Durum Telefonu Hatalı', 'Acil durumda ulaşılacak kişinin telefon numarasını 10 haneli olarak giriniz (başında 0 olmadan).')
      return
    }

    if (acilKisiTelefon === telefonNo) {
      showError('failed_required', 'Acil Durum Telefonu Hatalı', 'Acil durumda ulaşılacak kişinin telefon numarası kendi numaranızdan farklı olmalıdır.')
      return
    }

    if (!checkbox) {
      showError('failed_agreement')
      return
    }

    setConfirmModal({
      open: true,
      data: {
        adSoyad: `${uye?.adi || ''} ${uye?.soyadi || ''}`.trim(),
        tc: uye?.tc,
        dogumTarihi: uye?.dogum_tarihi_metin,
        cinsiyet: cinsiyetLabel(uye?.cinsiyet),
        kategori: preview?.kategori_etiketi,
        telefonNo,
        bloodType,
        adres: adres.trim(),
        acilKisi: `${acilKisiAdi.trim()} · ${acilKisiTelefon}`,
      },
    })
  }

  const submitToBackend = async () => {
    setLoading(true)

    const payload = {
      id: state?.basvuruId,
      telefon_no: telefonNo,
      adres: adres.trim(),
      kan_grubu: bloodType,
      acil_kisi_adi: acilKisiAdi.trim(),
      acil_kisi_telefon: acilKisiTelefon,
      contract_approved: checkbox,
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/atletizm-yarisi-create`, payload, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token')),
        },
      })

      if (res?.data?.code === 200) {
        navigate('/success-applications', { state: { id: res?.data?.result } })
      } else {
        showError('server_error', res?.data?.title || null, res?.data?.message || 'Bir hata oluştu.')
      }
    } catch (error) {
      showError('server_error', error.response?.data?.title || 'Sunucu Hatası', error.response?.data?.message || 'Bir hata oluştu')
    } finally {
      setLoading(false)
      setConfirmModal({ open: false, data: null })
    }
  }

  const inputStyle = {
    width: '90vw',
    borderRadius: '20px',
  }

  const labelStyle = {
    paddingLeft: '1.4rem',
    color: '#285843',
    fontWeight: 'bold',
    fontSize: '0.9rem',
  }

  const sectionTitleStyle = {
    paddingLeft: '1.4rem',
    color: '#285843',
    fontWeight: 'bold',
    fontSize: '1rem',
    marginTop: '1rem',
    marginBottom: '0.25rem',
  }

  const cardStyle = {
    marginTop: '0.75rem',
    marginLeft: '1rem',
    marginRight: '1rem',
    padding: '0.75rem',
    borderRadius: '12px',
    fontSize: '0.78rem',
    lineHeight: 1.5,
  }

  return (
    <>
      {loading ? (
        <Loading formText={'Başvurunuz alınıyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} />
      ) : (
        <div className='hide-scrollbar'>
          <div style={{ backgroundColor: '#fff', position: 'sticky', top: 0 }}>
            <Header onClick={() => navigate(-1)} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + state?.basvuru_fotografi} alt='' width={'90%'} style={{ borderRadius: '10px' }} />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1rem',
              marginBottom: '0.5rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingBottom: '0.5rem',
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: '#285843',
            }}
          >
            {state?.basvuru_aciklamasi}
          </div>

          {previewLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <Spinner style={{ color: '#285843' }} />
            </div>
          ) : (
            <>
              {/* Katılımcı bilgileri profilden gelir; başkası adına başvuru yapılamaz. */}
              <div style={sectionTitleStyle}>Katılımcı Bilgileri</div>

              <div
                style={{
                  ...cardStyle,
                  marginTop: '0.25rem',
                  backgroundColor: '#f7faf8',
                  border: '1px solid #d8e5dc',
                  color: '#285843',
                  fontSize: '0.85rem',
                }}
              >
                <Row label='Adı Soyadı' value={`${uye?.adi || ''} ${uye?.soyadi || ''}`.trim()} bold />
                <Row label='T.C. Kimlik No' value={uye?.tc} />
                <Row label='Doğum Tarihi' value={uye?.dogum_tarihi_metin} />
                <Row label='Cinsiyet' value={cinsiyetLabel(uye?.cinsiyet)} />
                <div style={{ marginTop: '0.5rem', fontSize: '0.72rem', color: '#7a8a82', lineHeight: 1.4 }}>
                  Bu bilgiler üyelik profilinizden alınmaktadır. Başvurular bireyseldir; başka bir kişi adına başvuru yapılamaz.
                </div>
              </div>

              {preview?.basvuru_var ? (
                <div
                  style={{
                    ...cardStyle,
                    backgroundColor: '#eef5f1',
                    border: '1px solid #285843',
                    color: '#285843',
                  }}
                >
                  <strong>Başvurunuz alınmıştır.</strong>
                  <div style={{ marginTop: '0.3rem' }}>{preview?.mesaj}</div>
                </div>
              ) : basvuruYapilabilir ? (
                <div
                  style={{
                    ...cardStyle,
                    backgroundColor: '#eef5f1',
                    border: '1px solid #285843',
                    color: '#285843',
                  }}
                >
                  <strong>Katılım Kategoriniz:</strong> {preview?.kategori_etiketi}
                  <div style={{ marginTop: '0.3rem', fontSize: '0.72rem' }}>
                    Kategoriniz doğum tarihiniz ve cinsiyetiniz esas alınarak otomatik belirlenmiştir.
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    ...cardStyle,
                    backgroundColor: '#fdecea',
                    border: '1px solid #d9534f',
                    color: '#7a1f1a',
                  }}
                >
                  <strong>Uyarı:</strong> {preview?.mesaj || 'Başvuru bilgileriniz doğrulanamadı.'}
                </div>
              )}

              {!preview?.basvuru_var && (
                <>
                  <div style={sectionTitleStyle}>İletişim ve Sağlık Bilgileri</div>

                  <Label style={labelStyle}>Cep Telefonu Numarası</Label>
                  <Input
                    style={inputStyle}
                    className='inputStyle'
                    value={telefonNo}
                    maxLength={10}
                    inputMode='numeric'
                    placeholder='5XXXXXXXXX'
                    onChange={(e) => setTelefonNo(normalizePhone(e.target.value))}
                  />

                  <Label style={labelStyle}>Adres</Label>
                  <Input style={inputStyle} className='inputStyle' type='textarea' rows={3} value={adres} maxLength={1000} onChange={(e) => setAdres(e.target.value)} />

                  <Label style={labelStyle}>Kan Grubu</Label>
                  <Input style={inputStyle} className='inputStyle' type='select' value={bloodType} onChange={(e) => setBloodType(e.target.value)}>
                    <option value=''>Seçiniz</option>
                    {KAN_GRUBU_OPTIONS.map((k) => (
                      <option key={k} value={k}>
                        {k}
                      </option>
                    ))}
                  </Input>

                  <div style={sectionTitleStyle}>Acil Durumda Ulaşılacak Kişi</div>

                  <Label style={labelStyle}>Adı Soyadı</Label>
                  <Input style={inputStyle} className='inputStyle' value={acilKisiAdi} maxLength={100} onChange={(e) => setAcilKisiAdi(e.target.value)} />

                  <Label style={labelStyle}>Telefon Numarası</Label>
                  <Input
                    style={inputStyle}
                    className='inputStyle'
                    value={acilKisiTelefon}
                    maxLength={10}
                    inputMode='numeric'
                    placeholder='5XXXXXXXXX'
                    onChange={(e) => setAcilKisiTelefon(normalizePhone(e.target.value))}
                  />
                </>
              )}

              <div
                style={{
                  ...cardStyle,
                  backgroundColor: '#fff8e1',
                  border: '1px solid #f0c674',
                  color: '#7a5d00',
                }}
              >
                <strong>Yarış Bilgileri</strong>
                <ul style={{ paddingLeft: '1.1rem', marginTop: '0.4rem', marginBottom: 0 }}>
                  {yaris?.adi && (
                    <li>
                      Program: <strong>{yaris.adi}</strong>
                    </li>
                  )}
                  {yaris?.tarih && (
                    <li>
                      Tarih: <strong>{yaris.tarih}</strong>
                    </li>
                  )}
                  {yaris?.yer && (
                    <li>
                      Yer: <strong>{yaris.yer}</strong>
                    </li>
                  )}
                  {yaris?.saat && (
                    <li>
                      Başlangıç saati: <strong>{yaris.saat}</strong>
                    </li>
                  )}
                  {yaris?.kesin_kayit && (
                    <li>
                      Kesin kayıt: <strong>{yaris.kesin_kayit}</strong>
                    </li>
                  )}
                  {yaris?.son_basvuru && (
                    <li>
                      Son başvuru: <strong>{yaris.son_basvuru}</strong>
                    </li>
                  )}
                </ul>
              </div>

              {yaris?.detay && (
                <div
                  className='yaris-detay-markdown'
                  style={{
                    ...cardStyle,
                    backgroundColor: '#eef5f1',
                    border: '1px solid #285843',
                    color: '#285843',
                    fontSize: '0.75rem',
                  }}
                >
                  <ReactMarkdown>{yaris.detay}</ReactMarkdown>
                </div>
              )}

              {!preview?.basvuru_var && (
                <>
                  <ConditionsCheckBox
                    checkbox={checkbox}
                    setCheckbox={setCheckbox}
                    basvuru_sartlari_title={state?.basvuru_sartlari_title}
                    basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.6rem',
                      marginTop: '1rem',
                      marginLeft: '1rem',
                      marginRight: '1rem',
                      padding: '0.75rem',
                      borderRadius: '12px',
                      backgroundColor: '#f7faf8',
                      border: '1px solid #d8e5dc',
                    }}
                  />

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '1rem',
                      marginBottom: '2rem',
                    }}
                  >
                    <Button
                      block
                      onClick={onFinish}
                      disabled={!basvuruYapilabilir}
                      style={{
                        marginLeft: '1rem',
                        marginRight: '1rem',
                        backgroundColor: '#285843',
                        border: 'none',
                        borderRadius: '14px',
                        padding: '0.75rem 1rem',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                        opacity: basvuruYapilabilir ? 1 : 0.55,
                        boxShadow: '0 4px 14px rgba(40, 88, 67, 0.25)',
                      }}
                    >
                      {loading ? <Spinner size={'sm'} /> : 'Başvuruyu Tamamla'}
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}

      <WarningModal isModal={isModal.active} messageType={isModal.type} messageTitle={isModal?.title} errorMessage={isModal?.message} toggleWarningModal={toggleWarningModal} />

      <Modal isOpen={confirmModal.open} centered toggle={() => !loading && setConfirmModal({ open: false, data: null })}>
        <ModalBody style={{ padding: '1.4rem 1.4rem 0.6rem' }}>
          <div style={{ textAlign: 'center', marginBottom: '0.9rem' }}>
            <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#285843' }}>Başvuru Özeti</div>
            <div style={{ fontSize: '0.78rem', color: '#7a8a82', marginTop: '0.2rem' }}>Aşağıdaki bilgilerle başvurunuz kaydedilecektir</div>
          </div>

          {confirmModal.data && (
            <div
              style={{
                backgroundColor: '#f7faf8',
                border: '1px solid #d8e5dc',
                borderRadius: '12px',
                padding: '0.9rem 1rem',
                fontSize: '0.85rem',
                color: '#285843',
                lineHeight: 1.7,
              }}
            >
              <Row label='Adı Soyadı' value={confirmModal.data.adSoyad} bold />
              <Row label='T.C. Kimlik No' value={confirmModal.data.tc} />
              <Row label='Doğum Tarihi' value={confirmModal.data.dogumTarihi} />
              <Row label='Cinsiyet' value={confirmModal.data.cinsiyet} />
              <Row label='Kategori' value={confirmModal.data.kategori} bold />
              <hr style={{ margin: '0.6rem 0', borderColor: '#d8e5dc' }} />
              <Row label='Telefon' value={confirmModal.data.telefonNo} />
              <Row label='Kan Grubu' value={confirmModal.data.bloodType} />
              <Row label='Acil Durum Kişisi' value={confirmModal.data.acilKisi} />
            </div>
          )}

          <div
            style={{
              marginTop: '0.9rem',
              fontSize: '0.78rem',
              color: '#7a5d00',
              backgroundColor: '#fff8e1',
              border: '1px solid #f0c674',
              borderRadius: '10px',
              padding: '0.55rem 0.75rem',
              textAlign: 'center',
            }}
          >
            Bilgiler doğru mu? Başvurunuz bu şekilde kaydedilecek.
          </div>
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none', padding: '0.6rem 1.2rem 1.2rem' }}>
          <Button
            onClick={() => setConfirmModal({ open: false, data: null })}
            disabled={loading}
            style={{
              flex: 1,
              backgroundColor: '#fff',
              color: '#285843',
              border: '1px solid #d8e5dc',
              borderRadius: '12px',
              padding: '0.65rem',
              fontWeight: 600,
            }}
          >
            Vazgeç
          </Button>
          <Button
            onClick={submitToBackend}
            disabled={loading}
            style={{
              flex: 1,
              backgroundColor: '#285843',
              border: 'none',
              borderRadius: '12px',
              padding: '0.65rem',
              fontWeight: 600,
              boxShadow: '0 4px 14px rgba(40, 88, 67, 0.25)',
            }}
          >
            {loading ? <Spinner size='sm' /> : 'Onayla'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AtletizmYarisiForm
